import { MemberContactEmailAddressEntity, MemberContactPhoneNumberEntity, MemberContactRoleEntity } from '.';
import { ContactType } from '../../types';
import { PendingEntity } from '../PendingEntity';

export class MemberContactEntity extends PendingEntity {
  firstName: string;
  lastName: string;
  department_En: string;
  department_Fr: string;
  isVisibleToMember: boolean;
  type: ContactType;
  roleId: number | null;
  role: MemberContactRoleEntity | null;
  emailAddresses: MemberContactEmailAddressEntity[];
  phoneNumbers: MemberContactPhoneNumberEntity[];
  isArchived: boolean;
  mailSyncError: string;
  mailSyncDate: Date;

  constructor(entity?: MemberContactEntity) {
    super(entity);
    if (entity) {
      Object.assign(this, { ...entity });
    } else {
      this.firstName = '';
      this.lastName = '';
      this.department_En = '';
      this.department_Fr = '';
      this.isVisibleToMember = false;
      this.type = ContactType.Person;
      this.roleId = null;
      this.role = null;
      this.emailAddresses = [];
      this.phoneNumbers = [];
    }
  }
}
